import React, { useState } from 'react';
import _cloneDeep from 'lodash/cloneDeep';

import Modal from '../modal';

import { IGDPRPreferences } from '../../../types/helpertext-config';

import './gdpr-modal.scss';

const GDPRModal = ({ savePreferences, preferences }: { savePreferences: Function; preferences: IGDPRPreferences }) => {
  const [gdprPreferences, setPreferences] = useState(_cloneDeep(preferences));

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedPreferences = { ...gdprPreferences };
    updatedPreferences[e.target.id.toLowerCase()].value = e.target.checked;
    setPreferences(updatedPreferences);
  };

  return (
    <Modal>
      <div className='gdpr-modal'>
        <div className='header'>
          <p className='title'>We use cookies on this site to enhance your user experience</p>
        </div>
        <div className='body'>
          {Object.keys(gdprPreferences).map((setting: string) => (
            <div className='gdpr-setting' key={setting}>
              <div className='inputwrapper'>
                <input
                  type='checkbox'
                  id={gdprPreferences[setting].label}
                  checked={gdprPreferences[setting].value}
                  onChange={(e) => handleInputChange(e)}
                  disabled={setting === 'necessary'}
                />
                <label htmlFor={gdprPreferences[setting].label}>{gdprPreferences[setting].label}</label>
              </div>
              <p>{gdprPreferences[setting].description}</p>
            </div>
          ))}
        </div>
        <div className='footer'>
          <button onClick={() => savePreferences(false, gdprPreferences)}>Save preferences</button>
          <button onClick={() => savePreferences(true, preferences)}>Accept all cookies</button>
        </div>
      </div>
    </Modal>
  );
};

export default GDPRModal;
